import { z } from 'zod/v4';
// Types of status updates that can occur on an order
export const StatusUpdateTypeSchema = z.enum([
    'status_change', // Order status changed
    'hold_applied', // Order placed on hold
    'hold_removed', // Order removed from hold
    'dispatched', // Dispatched to courier
    'email_sent', // Email sent to client
    'email_delivered', // Email delivery confirmed
    'email_failed', // Email delivery failed
    'document_added', // Document attached
    'note_added', // Internal note added
    'assignment_change', // Work assigned/reassigned
    'assignment_received', // Assignment received from upload/API
]);
// Email notification details embedded in status updates
export const EmailNotificationSchema = z.object({
    recipients: z.array(z.string().email()),
    subject: z.string().optional(),
    sentAt: z.string().datetime().optional(),
    deliveredAt: z.string().datetime().optional(),
    failedAt: z.string().datetime().optional(),
    failureReason: z.string().optional(),
});
// Reference to a related order
export const RelatedOrderReferenceSchema = z.object({
    id: z.string().uuid(),
    orderNumber: z.string(),
    caseNumber: z.string().optional(),
});
// Main OrderStatusUpdate schema
export const OrderStatusUpdateSchema = z.object({
    id: z.string().uuid(),
    orderId: z.string().uuid(),
    type: StatusUpdateTypeSchema,
    statusLabel: z.string(), // "Order Pending", "Dispatched to courier"
    previousStatus: z.string().optional(),
    newStatus: z.string().optional(),
    relatedOrders: z.array(RelatedOrderReferenceSchema).optional(),
    emailNotification: EmailNotificationSchema.optional(),
    isInternal: z.boolean().default(false),
    note: z.string().optional(),
    emailNote: z.string().optional(),
    dispatchDetails: z.object({
        courierName: z.string(),
        courierPhone: z.string().optional(),
        courierEmail: z.string().email().optional(),
        fromCompany: z.string().optional(),
    }).optional(),
    createdById: z.string().uuid(),
    createdByName: z.string(),
    createdAt: z.string().datetime(),
});
// List response for paginated status updates
export const OrderStatusUpdatesResponseSchema = z.object({
    updates: z.array(OrderStatusUpdateSchema),
    orderId: z.string().uuid(),
    emailRecipients: z.array(z.string().email()).optional(),
    totalCount: z.number(),
});
